export const USER_INVITATIONS_STATE_MUTATIONS = {
    SET_USER_INVITATION: 'SET_USER_INVITATION',
    REMOVE_USER_INVITATION: 'REMOVE_USER',
};
export const USER_INVITATIONS_STATE_GETTERS = {
    FIRST_USER_INVITATION: 'FIRST_USER_INVITATION',
};
const INITIAL_USER_INVITATIONS_STATE = {
    userInvitations: [],
};
const initState = () => JSON.parse(JSON.stringify(INITIAL_USER_INVITATIONS_STATE));
export class UserInvitationsStore {
    constructor() {
        this.namespaced = true;
        this.state = initState();
        this.getters = {
            [USER_INVITATIONS_STATE_GETTERS.FIRST_USER_INVITATION]: (state) => state.userInvitations[0],
        };
        this.mutations = {
            [USER_INVITATIONS_STATE_MUTATIONS.SET_USER_INVITATION](state, userInvitationUuid) {
                if (!state.userInvitations.find(uuid => uuid === userInvitationUuid) && userInvitationUuid) {
                    state.userInvitations.push(userInvitationUuid);
                }
            },
            [USER_INVITATIONS_STATE_MUTATIONS.REMOVE_USER_INVITATION](state, userInvitationUuid) {
                const index = state.userInvitations.findIndex(uuid => uuid === userInvitationUuid);
                if (index !== -1) {
                    state.userInvitations.splice(index, 1);
                }
            },
        };
        this.actions = {};
    }
}
UserInvitationsStore.NS = 'user-invitations';
